var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-subtitle',[_c('v-icon',{staticClass:"mr-1"},[_vm._v("email")]),_vm._v("\n      Email Address\n    ")],1),_vm._v(" "),_c('v-list-item-title',[_vm._v(_vm._s(_vm.emailProp === '  ' ? '...' : _vm.emailProp))])],1),_vm._v(" "),_c('v-list-item-action')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d8c1df4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/email.vue
// module id = null
// module chunks = 